import { Banner } from "@shopify/polaris"
import React from "react"
import { useTranslation } from "react-i18next"

const LimitedRefDbSearchBanner = () => {
  const { t } = useTranslation()

  return (
    <Banner
      title={t(`reference_database:banners.limited_search.title`)}
      status="info"
    >
      {t(`reference_database:banners.limited_search.description`)}
    </Banner>
  )
}

export default LimitedRefDbSearchBanner
